export default {
  strict: true,
  namespaced: true,
  state: {
    track: {
      enable: false,
      pnr: '',
      firstName: '',
      lastName: ''
    }
  },
  mutations: {
    setFlightTrackData (state, data) {
      for (let field in data) {
        state.track[field] = data[field]
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/flights/track.js